import * as ListingImage1 from "../models/ListingImage1";
import * as ListingDocument2 from "../models/ListingDocument2";
import * as ListingDocumentUrl from "../models/ListingDocumentUrl";

// A floorplan is stored as a document, not a photo, and is frequently a PDF. Only the
// raster ones can join the gallery; a PDF stays a download link in Documents.
const GALLERYABLE_MIME_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif"];

export const isGalleryableFloorplan = (document: ListingDocument2.T): boolean =>
    document.document_type === "floorplan"
    && GALLERYABLE_MIME_TYPES.includes(document.mime_type.toLowerCase());

// Last, not first: buyers come for the photos, and a floorplan opening the carousel buries
// them. It still gets its own frame and counts towards the gallery's "1 / N".
export const listingGalleryImages = (
    images: Array<ListingImage1.T>,
    documents: Array<ListingDocument2.T>,
    accountName: string,
): Array<ListingImage1.T> => [
    ...images,
    ...documents
        .filter(isGalleryableFloorplan)
        .map((document) => ({
            id: document.id,
            name: "Floor plan",
            url: ListingDocumentUrl.fromListingDocument2AndAccountName(document, accountName),
        })),
];
